import type { BillingUsageDto } from '@shared/services/apiService';
const DAY = 86400000;
/** Advisory only: exact units, complete UTC days, at most seven days of the same credit policy. */
export function billingForecast(
  usage: BillingUsageDto,
  endsAt: string | null,
  availableUnits: string,
) {
  if (!endsAt || !/^\d+$/.test(availableUnits)) return null;
  const now = Date.parse(usage.asOf),
    end = Date.parse(endsAt),
    start = Math.ceil(Date.parse(usage.from) / DAY) * DAY;
  if (!Number.isFinite(now) || !Number.isFinite(end) || end <= now) return null;
  const today = Math.floor(now / DAY) * DAY;
  const days = usage.days.filter((d) => {
    const at = Date.parse(d.date);
    return at >= Math.max(start, today - 7 * DAY) && at < today;
  });
  if (days.length < 3) return null;
  const sum = days.reduce((n, d) => n + BigInt(d.totalUnits), 0n);
  if (sum <= 0n) return null;
  const denominator = BigInt(days.length) * BigInt(DAY);
  const projected = (sum * BigInt(end - now) + denominator - 1n) / denominator;
  const available = BigInt(availableUnits);
  return {
    sampleDays: days.length,
    projectedUnits: projected.toString(),
    shortfallUnits: (projected > available ? projected - available : 0n).toString(),
  };
}
